// @generated by Peggy 5.1.0.
//
// https://peggyjs.org/


class peg$SyntaxError extends SyntaxError {
  constructor(message, expected, found, location) {
    super(message);
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";
  }

  format(sources) {
    let str = "Error: " + this.message;
    if (this.location) {
      let src = null;
      const st = sources.find(s => s.source === this.location.source);
      if (st) {
        src = st.text.split(/\r\n|\n|\r/g);
      }
      const s = this.location.start;
      const offset_s = (this.location.source && (typeof this.location.source.offset === "function"))
        ? this.location.source.offset(s)
        : s;
      const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
      if (src) {
        const e = this.location.end;
        const filler = "".padEnd(offset_s.line.toString().length, " ");
        const line = src[s.line - 1];
        const last = s.line === e.line ? e.column : line.length + 1;
        const hatLen = (last - s.column) || 1;
        str += "\n --> " + loc + "\n"
            + filler + " |\n"
            + offset_s.line + " | " + line + "\n"
            + filler + " | " + "".padEnd(s.column - 1, " ")
            + "".padEnd(hatLen, "^");
      } else {
        str += "\n at " + loc;
      }
    }
    return str;
  }

  static buildMessage(expected, found) {
    function hex(ch) {
      return ch.codePointAt(0).toString(16).toUpperCase();
    }

    const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode")
      ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu")
      : null;
    function unicodeEscape(s) {
      if (nonPrintable) {
        return s.replace(nonPrintable,  ch => "\\u{" + hex(ch) + "}");
      }
      return s;
    }

    function literalEscape(s) {
      return unicodeEscape(s
        .replace(/\\/g, "\\\\")
        .replace(/"/g,  "\\\"")
        .replace(/\0/g, "\\0")
        .replace(/\t/g, "\\t")
        .replace(/\n/g, "\\n")
        .replace(/\r/g, "\\r")
        .replace(/[\x00-\x0F]/g,          ch => "\\x0" + hex(ch))
        .replace(/[\x10-\x1F\x7F-\x9F]/g, ch => "\\x"  + hex(ch)));
    }

    function classEscape(s) {
      return unicodeEscape(s
        .replace(/\\/g, "\\\\")
        .replace(/\]/g, "\\]")
        .replace(/\^/g, "\\^")
        .replace(/-/g,  "\\-")
        .replace(/\0/g, "\\0")
        .replace(/\t/g, "\\t")
        .replace(/\n/g, "\\n")
        .replace(/\r/g, "\\r")
        .replace(/[\x00-\x0F]/g,          ch => "\\x0" + hex(ch))
        .replace(/[\x10-\x1F\x7F-\x9F]/g, ch => "\\x"  + hex(ch)));
    }

    const DESCRIBE_EXPECTATION_FNS = {
      literal(expectation) {
        return "\"" + literalEscape(expectation.text) + "\"";
      },

      class(expectation) {
        const escapedParts = expectation.parts.map(
          part => (Array.isArray(part)
            ? classEscape(part[0]) + "-" + classEscape(part[1])
            : classEscape(part))
        );

        return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
      },

      any() {
        return "any character";
      },

      end() {
        return "end of input";
      },

      other(expectation) {
        return expectation.description;
      },
    };

    function describeExpectation(expectation) {
      return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
    }

    function describeExpected(expected) {
      const descriptions = expected.map(describeExpectation);
      descriptions.sort();

      if (descriptions.length > 0) {
        let j = 1;
        for (let i = 1; i < descriptions.length; i++) {
          if (descriptions[i - 1] !== descriptions[i]) {
            descriptions[j] = descriptions[i];
            j++;
          }
        }
        descriptions.length = j;
      }

      switch (descriptions.length) {
        case 1:
          return descriptions[0];

        case 2:
          return descriptions[0] + " or " + descriptions[1];

        default:
          return descriptions.slice(0, -1).join(", ")
            + ", or "
            + descriptions[descriptions.length - 1];
      }
    }

    function describeFound(found) {
      return found ? "\"" + literalEscape(found) + "\"" : "end of input";
    }

    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
  }
}

function peg$parse(input, options) {
  options = options !== undefined ? options : {};

  const peg$FAILED = {};
  const peg$source = options.grammarSource;

  const peg$startRuleFunctions = {
    Expression: peg$parseExpression,
  };
  let peg$startRuleFunction = peg$parseExpression;

  const peg$c0 = "(";
  const peg$c1 = ")";
  const peg$c2 = "add";
  const peg$c3 = "all";
  const peg$c4 = "alter";
  const peg$c5 = "and";
  const peg$c6 = "any";
  const peg$c7 = "as";
  const peg$c8 = "asc";
  const peg$c9 = "backup";
  const peg$c10 = "between";
  const peg$c11 = "by";
  const peg$c12 = "case";
  const peg$c13 = "check";
  const peg$c14 = "column";
  const peg$c15 = "constraint";
  const peg$c16 = "count";
  const peg$c17 = "create";
  const peg$c18 = "database";
  const peg$c19 = "default";
  const peg$c20 = "delete";
  const peg$c21 = "desc";
  const peg$c22 = "distinct";
  const peg$c23 = "drop";
  const peg$c24 = "exec";
  const peg$c25 = "exists";
  const peg$c26 = "foreign";
  const peg$c27 = "from";
  const peg$c28 = "full";
  const peg$c29 = "group";
  const peg$c30 = "having";
  const peg$c31 = "inner";
  const peg$c32 = "insert";
  const peg$c33 = "join";
  const peg$c34 = "key";
  const peg$c35 = "left";
  const peg$c36 = "limit";
  const peg$c37 = "offset";
  const peg$c38 = "on";
  const peg$c39 = "order";
  const peg$c40 = "outer";
  const peg$c41 = "returning";
  const peg$c42 = "right";
  const peg$c43 = "select";
  const peg$c44 = "set";
  const peg$c45 = "table";
  const peg$c46 = "update";
  const peg$c47 = "values";
  const peg$c48 = "where";
  const peg$c49 = "%s";
  const peg$c50 = ":c";
  const peg$c51 = "..";

  const peg$r0 = /^[0-9]/;
  const peg$r1 = /^[\n\t\r ]/;
  const peg$r2 = /^[a-zA-Z0-9\xA0-\uFFFF"'`_\-.=><:,*;![\]?$%|\/\\@#&~\^+{}]/;

  const peg$e0 = peg$literalExpectation("(", false);
  const peg$e1 = peg$literalExpectation(")", false);
  const peg$e2 = peg$literalExpectation("ADD", true);
  const peg$e3 = peg$literalExpectation("ALL", true);
  const peg$e4 = peg$literalExpectation("ALTER", true);
  const peg$e5 = peg$literalExpectation("AND", true);
  const peg$e6 = peg$literalExpectation("ANY", true);
  const peg$e7 = peg$literalExpectation("AS", true);
  const peg$e8 = peg$literalExpectation("ASC", true);
  const peg$e9 = peg$literalExpectation("BACKUP", true);
  const peg$e10 = peg$literalExpectation("BETWEEN", true);
  const peg$e11 = peg$literalExpectation("BY", true);
  const peg$e12 = peg$literalExpectation("CASE", true);
  const peg$e13 = peg$literalExpectation("CHECK", true);
  const peg$e14 = peg$literalExpectation("COLUMN", true);
  const peg$e15 = peg$literalExpectation("CONSTRAINT", true);
  const peg$e16 = peg$literalExpectation("COUNT", true);
  const peg$e17 = peg$literalExpectation("CREATE", true);
  const peg$e18 = peg$literalExpectation("DATABASE", true);
  const peg$e19 = peg$literalExpectation("DEFAULT", true);
  const peg$e20 = peg$literalExpectation("DELETE", true);
  const peg$e21 = peg$literalExpectation("DESC", true);
  const peg$e22 = peg$literalExpectation("DISTINCT", true);
  const peg$e23 = peg$literalExpectation("DROP", true);
  const peg$e24 = peg$literalExpectation("EXEC", true);
  const peg$e25 = peg$literalExpectation("EXISTS", true);
  const peg$e26 = peg$literalExpectation("FOREIGN", true);
  const peg$e27 = peg$literalExpectation("FROM", true);
  const peg$e28 = peg$literalExpectation("FULL", true);
  const peg$e29 = peg$literalExpectation("GROUP", true);
  const peg$e30 = peg$literalExpectation("HAVING", true);
  const peg$e31 = peg$literalExpectation("INNER", true);
  const peg$e32 = peg$literalExpectation("INSERT", true);
  const peg$e33 = peg$literalExpectation("JOIN", true);
  const peg$e34 = peg$literalExpectation("KEY", true);
  const peg$e35 = peg$literalExpectation("LEFT", true);
  const peg$e36 = peg$literalExpectation("LIMIT", true);
  const peg$e37 = peg$literalExpectation("OFFSET", true);
  const peg$e38 = peg$literalExpectation("ON", true);
  const peg$e39 = peg$literalExpectation("ORDER", true);
  const peg$e40 = peg$literalExpectation("OUTER", true);
  const peg$e41 = peg$literalExpectation("RETURNING", true);
  const peg$e42 = peg$literalExpectation("RIGHT", true);
  const peg$e43 = peg$literalExpectation("SELECT", true);
  const peg$e44 = peg$literalExpectation("SET", true);
  const peg$e45 = peg$literalExpectation("TABLE", true);
  const peg$e46 = peg$literalExpectation("UPDATE", true);
  const peg$e47 = peg$literalExpectation("VALUES", true);
  const peg$e48 = peg$literalExpectation("WHERE", true);
  const peg$e49 = peg$literalExpectation("%s", false);
  const peg$e50 = peg$literalExpectation(":c", false);
  const peg$e51 = peg$classExpectation([["0", "9"]], false, false, false);
  const peg$e52 = peg$literalExpectation("..", false);
  const peg$e53 = peg$classExpectation(["\n", "\t", "\r", " "], false, false, false);
  const peg$e54 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], ["\xA0", "\uFFFF"], "\"", "'", "`", "_", "-", ".", "=", ">", "<", ":", ",", "*", ";", "!", "[", "]", "?", "$", "%", "|", "/", "\\", "@", "#", "&", "~", "^", "+", "{", "}"], false, false, false);

  function peg$f0() {    return { type: 'LeftParenthesis', content: '(' }  }
  function peg$f1() {    return { type: 'RightParenthesis', content: ')' }  }
  function peg$f2(Keyword) {
    return { type: 'Keyword', content: Keyword.toUpperCase() }
  }
  function peg$f3(JoinDirection, JoinType) {
    return (JoinDirection || '') + (JoinDirection ? " " : '') + JoinType + " " + "JOIN"
  }
  function peg$f4(Parameter) {    return { type: 'Parameter', content: Array.isArray(Parameter) ? Parameter.join('') : Parameter }  }
  function peg$f5() {    return { type: 'CollapsedColumns', content: '..' }  }
  function peg$f6(Whitespace) {    return { type: 'Whitespace', content: Whitespace.join("") }  }
  function peg$f7(GenericToken) {    return { type: 'GenericToken', content: GenericToken.join('') }  }
  let peg$currPos = options.peg$currPos | 0;
  let peg$savedPos = peg$currPos;
  const peg$posDetailsCache = [{ line: 1, column: 1 }];
  let peg$maxFailPos = peg$currPos;
  let peg$maxFailExpected = options.peg$maxFailExpected || [];
  let peg$silentFails = options.peg$silentFails | 0;

  let peg$result;

  if (options.startRule) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function offset() {
    return peg$savedPos;
  }

  function range() {
    return {
      source: peg$source,
      start: peg$savedPos,
      end: peg$currPos,
    };
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    );
  }

  function error(message, location) {
    location = location !== undefined
      ? location
      : peg$computeLocation(peg$savedPos, peg$currPos);

    throw peg$buildSimpleError(message, location);
  }

  function peg$getUnicode(pos = peg$currPos) {
    const cp = input.codePointAt(pos);
    if (cp === undefined) {
      return "";
    }
    return String.fromCodePoint(cp);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text, ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
    return { type: "class", parts, inverted, ignoreCase, unicode };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$otherExpectation(description) {
    return { type: "other", description };
  }

  function peg$computePosDetails(pos) {
    let details = peg$posDetailsCache[pos];
    let p;

    if (details) {
      return details;
    } else {
      if (pos >= peg$posDetailsCache.length) {
        p = peg$posDetailsCache.length - 1;
      } else {
        p = pos;
        while (!peg$posDetailsCache[--p]) {}
      }

      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column,
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;

      return details;
    }
  }

  function peg$computeLocation(startPos, endPos, offset) {
    const startPosDetails = peg$computePosDetails(startPos);
    const endPosDetails = peg$computePosDetails(endPos);

    const res = {
      source: peg$source,
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column,
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column,
      },
    };
    if (offset && peg$source && (typeof peg$source.offset === "function")) {
      res.start = peg$source.offset(res.start);
      res.end = peg$source.offset(res.end);
    }
    return res;
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parseExpression() {
    let s0, s1;

    s0 = [];
    s1 = peg$parseToken();
    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parseToken();
    }

    return s0;
  }

  function peg$parseToken() {
    let s0;

    s0 = peg$parseLeftParenthesis();
    if (s0 === peg$FAILED) {
      s0 = peg$parseRightParenthesis();
      if (s0 === peg$FAILED) {
        s0 = peg$parseWhitespace();
        if (s0 === peg$FAILED) {
          s0 = peg$parseKeyword();
          if (s0 === peg$FAILED) {
            s0 = peg$parseParameter();
            if (s0 === peg$FAILED) {
              s0 = peg$parseCollapsedColumns();
              if (s0 === peg$FAILED) {
                s0 = peg$parseGenericToken();
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseLeftParenthesis() {
    let s0, s1;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 40) {
      s1 = peg$c0;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e0); }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f0();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseRightParenthesis() {
    let s0, s1;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 41) {
      s1 = peg$c1;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e1); }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f1();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseKeyword() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c2) {
      peg$currPos += (3);
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e2); }
    }
    if (s1 === peg$FAILED) {
      s1 = input.substr(peg$currPos, 3);
      if (s1.toLowerCase() === peg$c3) {
        peg$currPos += (3);
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e3); }
      }
      if (s1 === peg$FAILED) {
        s1 = input.substr(peg$currPos, 5);
        if (s1.toLowerCase() === peg$c4) {
          peg$currPos += (5);
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e4); }
        }
        if (s1 === peg$FAILED) {
          s1 = input.substr(peg$currPos, 3);
          if (s1.toLowerCase() === peg$c5) {
            peg$currPos += (3);
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$e5); }
          }
          if (s1 === peg$FAILED) {
            s1 = input.substr(peg$currPos, 3);
            if (s1.toLowerCase() === peg$c6) {
              peg$currPos += (3);
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$e6); }
            }
            if (s1 === peg$FAILED) {
              s1 = input.substr(peg$currPos, 2);
              if (s1.toLowerCase() === peg$c7) {
                peg$currPos += (2);
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$e7); }
              }
              if (s1 === peg$FAILED) {
                s1 = input.substr(peg$currPos, 3);
                if (s1.toLowerCase() === peg$c8) {
                  peg$currPos += (3);
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$e8); }
                }
                if (s1 === peg$FAILED) {
                  s1 = input.substr(peg$currPos, 6);
                  if (s1.toLowerCase() === peg$c9) {
                    peg$currPos += (6);
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$e9); }
                  }
                  if (s1 === peg$FAILED) {
                    s1 = input.substr(peg$currPos, 7);
                    if (s1.toLowerCase() === peg$c10) {
                      peg$currPos += (7);
                    } else {
                      s1 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$e10); }
                    }
                    if (s1 === peg$FAILED) {
                      s1 = input.substr(peg$currPos, 2);
                      if (s1.toLowerCase() === peg$c11) {
                        peg$currPos += (2);
                      } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$e11); }
                      }
                      if (s1 === peg$FAILED) {
                        s1 = input.substr(peg$currPos, 4);
                        if (s1.toLowerCase() === peg$c12) {
                          peg$currPos += (4);
                        } else {
                          s1 = peg$FAILED;
                          if (peg$silentFails === 0) { peg$fail(peg$e12); }
                        }
                        if (s1 === peg$FAILED) {
                          s1 = input.substr(peg$currPos, 5);
                          if (s1.toLowerCase() === peg$c13) {
                            peg$currPos += (5);
                          } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) { peg$fail(peg$e13); }
                          }
                          if (s1 === peg$FAILED) {
                            s1 = input.substr(peg$currPos, 6);
                            if (s1.toLowerCase() === peg$c14) {
                              peg$currPos += (6);
                            } else {
                              s1 = peg$FAILED;
                              if (peg$silentFails === 0) { peg$fail(peg$e14); }
                            }
                            if (s1 === peg$FAILED) {
                              s1 = input.substr(peg$currPos, 10);
                              if (s1.toLowerCase() === peg$c15) {
                                peg$currPos += (10);
                              } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) { peg$fail(peg$e15); }
                              }
                              if (s1 === peg$FAILED) {
                                s1 = input.substr(peg$currPos, 5);
                                if (s1.toLowerCase() === peg$c16) {
                                  peg$currPos += (5);
                                } else {
                                  s1 = peg$FAILED;
                                  if (peg$silentFails === 0) { peg$fail(peg$e16); }
                                }
                                if (s1 === peg$FAILED) {
                                  s1 = input.substr(peg$currPos, 6);
                                  if (s1.toLowerCase() === peg$c17) {
                                    peg$currPos += (6);
                                  } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) { peg$fail(peg$e17); }
                                  }
                                  if (s1 === peg$FAILED) {
                                    s1 = input.substr(peg$currPos, 8);
                                    if (s1.toLowerCase() === peg$c18) {
                                      peg$currPos += (8);
                                    } else {
                                      s1 = peg$FAILED;
                                      if (peg$silentFails === 0) { peg$fail(peg$e18); }
                                    }
                                    if (s1 === peg$FAILED) {
                                      s1 = input.substr(peg$currPos, 7);
                                      if (s1.toLowerCase() === peg$c19) {
                                        peg$currPos += (7);
                                      } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) { peg$fail(peg$e19); }
                                      }
                                      if (s1 === peg$FAILED) {
                                        s1 = input.substr(peg$currPos, 6);
                                        if (s1.toLowerCase() === peg$c20) {
                                          peg$currPos += (6);
                                        } else {
                                          s1 = peg$FAILED;
                                          if (peg$silentFails === 0) { peg$fail(peg$e20); }
                                        }
                                        if (s1 === peg$FAILED) {
                                          s1 = input.substr(peg$currPos, 4);
                                          if (s1.toLowerCase() === peg$c21) {
                                            peg$currPos += (4);
                                          } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) { peg$fail(peg$e21); }
                                          }
                                          if (s1 === peg$FAILED) {
                                            s1 = input.substr(peg$currPos, 8);
                                            if (s1.toLowerCase() === peg$c22) {
                                              peg$currPos += (8);
                                            } else {
                                              s1 = peg$FAILED;
                                              if (peg$silentFails === 0) { peg$fail(peg$e22); }
                                            }
                                            if (s1 === peg$FAILED) {
                                              s1 = input.substr(peg$currPos, 4);
                                              if (s1.toLowerCase() === peg$c23) {
                                                peg$currPos += (4);
                                              } else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) { peg$fail(peg$e23); }
                                              }
                                              if (s1 === peg$FAILED) {
                                                s1 = input.substr(peg$currPos, 4);
                                                if (s1.toLowerCase() === peg$c24) {
                                                  peg$currPos += (4);
                                                } else {
                                                  s1 = peg$FAILED;
                                                  if (peg$silentFails === 0) { peg$fail(peg$e24); }
                                                }
                                                if (s1 === peg$FAILED) {
                                                  s1 = input.substr(peg$currPos, 6);
                                                  if (s1.toLowerCase() === peg$c25) {
                                                    peg$currPos += (6);
                                                  } else {
                                                    s1 = peg$FAILED;
                                                    if (peg$silentFails === 0) { peg$fail(peg$e25); }
                                                  }
                                                  if (s1 === peg$FAILED) {
                                                    s1 = input.substr(peg$currPos, 7);
                                                    if (s1.toLowerCase() === peg$c26) {
                                                      peg$currPos += (7);
                                                    } else {
                                                      s1 = peg$FAILED;
                                                      if (peg$silentFails === 0) { peg$fail(peg$e26); }
                                                    }
                                                    if (s1 === peg$FAILED) {
                                                      s1 = input.substr(peg$currPos, 4);
                                                      if (s1.toLowerCase() === peg$c27) {
                                                        peg$currPos += (4);
                                                      } else {
                                                        s1 = peg$FAILED;
                                                        if (peg$silentFails === 0) { peg$fail(peg$e27); }
                                                      }
                                                      if (s1 === peg$FAILED) {
                                                        s1 = input.substr(peg$currPos, 4);
                                                        if (s1.toLowerCase() === peg$c27) {
                                                          peg$currPos += (4);
                                                        } else {
                                                          s1 = peg$FAILED;
                                                          if (peg$silentFails === 0) { peg$fail(peg$e27); }
                                                        }
                                                        if (s1 === peg$FAILED) {
                                                          s1 = input.substr(peg$currPos, 4);
                                                          if (s1.toLowerCase() === peg$c28) {
                                                            peg$currPos += (4);
                                                          } else {
                                                            s1 = peg$FAILED;
                                                            if (peg$silentFails === 0) { peg$fail(peg$e28); }
                                                          }
                                                          if (s1 === peg$FAILED) {
                                                            s1 = input.substr(peg$currPos, 5);
                                                            if (s1.toLowerCase() === peg$c29) {
                                                              peg$currPos += (5);
                                                            } else {
                                                              s1 = peg$FAILED;
                                                              if (peg$silentFails === 0) { peg$fail(peg$e29); }
                                                            }
                                                            if (s1 === peg$FAILED) {
                                                              s1 = input.substr(peg$currPos, 6);
                                                              if (s1.toLowerCase() === peg$c30) {
                                                                peg$currPos += (6);
                                                              } else {
                                                                s1 = peg$FAILED;
                                                                if (peg$silentFails === 0) { peg$fail(peg$e30); }
                                                              }
                                                              if (s1 === peg$FAILED) {
                                                                s1 = input.substr(peg$currPos, 5);
                                                                if (s1.toLowerCase() === peg$c31) {
                                                                  peg$currPos += (5);
                                                                } else {
                                                                  s1 = peg$FAILED;
                                                                  if (peg$silentFails === 0) { peg$fail(peg$e31); }
                                                                }
                                                                if (s1 === peg$FAILED) {
                                                                  s1 = input.substr(peg$currPos, 6);
                                                                  if (s1.toLowerCase() === peg$c32) {
                                                                    peg$currPos += (6);
                                                                  } else {
                                                                    s1 = peg$FAILED;
                                                                    if (peg$silentFails === 0) { peg$fail(peg$e32); }
                                                                  }
                                                                  if (s1 === peg$FAILED) {
                                                                    s1 = input.substr(peg$currPos, 4);
                                                                    if (s1.toLowerCase() === peg$c33) {
                                                                      peg$currPos += (4);
                                                                    } else {
                                                                      s1 = peg$FAILED;
                                                                      if (peg$silentFails === 0) { peg$fail(peg$e33); }
                                                                    }
                                                                    if (s1 === peg$FAILED) {
                                                                      s1 = input.substr(peg$currPos, 3);
                                                                      if (s1.toLowerCase() === peg$c34) {
                                                                        peg$currPos += (3);
                                                                      } else {
                                                                        s1 = peg$FAILED;
                                                                        if (peg$silentFails === 0) { peg$fail(peg$e34); }
                                                                      }
                                                                      if (s1 === peg$FAILED) {
                                                                        s1 = input.substr(peg$currPos, 4);
                                                                        if (s1.toLowerCase() === peg$c35) {
                                                                          peg$currPos += (4);
                                                                        } else {
                                                                          s1 = peg$FAILED;
                                                                          if (peg$silentFails === 0) { peg$fail(peg$e35); }
                                                                        }
                                                                        if (s1 === peg$FAILED) {
                                                                          s1 = input.substr(peg$currPos, 5);
                                                                          if (s1.toLowerCase() === peg$c36) {
                                                                            peg$currPos += (5);
                                                                          } else {
                                                                            s1 = peg$FAILED;
                                                                            if (peg$silentFails === 0) { peg$fail(peg$e36); }
                                                                          }
                                                                          if (s1 === peg$FAILED) {
                                                                            s1 = input.substr(peg$currPos, 6);
                                                                            if (s1.toLowerCase() === peg$c37) {
                                                                              peg$currPos += (6);
                                                                            } else {
                                                                              s1 = peg$FAILED;
                                                                              if (peg$silentFails === 0) { peg$fail(peg$e37); }
                                                                            }
                                                                            if (s1 === peg$FAILED) {
                                                                              s1 = input.substr(peg$currPos, 2);
                                                                              if (s1.toLowerCase() === peg$c38) {
                                                                                peg$currPos += (2);
                                                                              } else {
                                                                                s1 = peg$FAILED;
                                                                                if (peg$silentFails === 0) { peg$fail(peg$e38); }
                                                                              }
                                                                              if (s1 === peg$FAILED) {
                                                                                s1 = input.substr(peg$currPos, 5);
                                                                                if (s1.toLowerCase() === peg$c39) {
                                                                                  peg$currPos += (5);
                                                                                } else {
                                                                                  s1 = peg$FAILED;
                                                                                  if (peg$silentFails === 0) { peg$fail(peg$e39); }
                                                                                }
                                                                                if (s1 === peg$FAILED) {
                                                                                  s1 = input.substr(peg$currPos, 5);
                                                                                  if (s1.toLowerCase() === peg$c40) {
                                                                                    peg$currPos += (5);
                                                                                  } else {
                                                                                    s1 = peg$FAILED;
                                                                                    if (peg$silentFails === 0) { peg$fail(peg$e40); }
                                                                                  }
                                                                                  if (s1 === peg$FAILED) {
                                                                                    s1 = input.substr(peg$currPos, 9);
                                                                                    if (s1.toLowerCase() === peg$c41) {
                                                                                      peg$currPos += (9);
                                                                                    } else {
                                                                                      s1 = peg$FAILED;
                                                                                      if (peg$silentFails === 0) { peg$fail(peg$e41); }
                                                                                    }
                                                                                    if (s1 === peg$FAILED) {
                                                                                      s1 = input.substr(peg$currPos, 5);
                                                                                      if (s1.toLowerCase() === peg$c42) {
                                                                                        peg$currPos += (5);
                                                                                      } else {
                                                                                        s1 = peg$FAILED;
                                                                                        if (peg$silentFails === 0) { peg$fail(peg$e42); }
                                                                                      }
                                                                                      if (s1 === peg$FAILED) {
                                                                                        s1 = input.substr(peg$currPos, 6);
                                                                                        if (s1.toLowerCase() === peg$c43) {
                                                                                          peg$currPos += (6);
                                                                                        } else {
                                                                                          s1 = peg$FAILED;
                                                                                          if (peg$silentFails === 0) { peg$fail(peg$e43); }
                                                                                        }
                                                                                        if (s1 === peg$FAILED) {
                                                                                          s1 = input.substr(peg$currPos, 6);
                                                                                          if (s1.toLowerCase() === peg$c43) {
                                                                                            peg$currPos += (6);
                                                                                          } else {
                                                                                            s1 = peg$FAILED;
                                                                                            if (peg$silentFails === 0) { peg$fail(peg$e43); }
                                                                                          }
                                                                                          if (s1 === peg$FAILED) {
                                                                                            s1 = input.substr(peg$currPos, 3);
                                                                                            if (s1.toLowerCase() === peg$c44) {
                                                                                              peg$currPos += (3);
                                                                                            } else {
                                                                                              s1 = peg$FAILED;
                                                                                              if (peg$silentFails === 0) { peg$fail(peg$e44); }
                                                                                            }
                                                                                            if (s1 === peg$FAILED) {
                                                                                              s1 = input.substr(peg$currPos, 5);
                                                                                              if (s1.toLowerCase() === peg$c45) {
                                                                                                peg$currPos += (5);
                                                                                              } else {
                                                                                                s1 = peg$FAILED;
                                                                                                if (peg$silentFails === 0) { peg$fail(peg$e45); }
                                                                                              }
                                                                                              if (s1 === peg$FAILED) {
                                                                                                s1 = input.substr(peg$currPos, 6);
                                                                                                if (s1.toLowerCase() === peg$c46) {
                                                                                                  peg$currPos += (6);
                                                                                                } else {
                                                                                                  s1 = peg$FAILED;
                                                                                                  if (peg$silentFails === 0) { peg$fail(peg$e46); }
                                                                                                }
                                                                                                if (s1 === peg$FAILED) {
                                                                                                  s1 = input.substr(peg$currPos, 6);
                                                                                                  if (s1.toLowerCase() === peg$c47) {
                                                                                                    peg$currPos += (6);
                                                                                                  } else {
                                                                                                    s1 = peg$FAILED;
                                                                                                    if (peg$silentFails === 0) { peg$fail(peg$e47); }
                                                                                                  }
                                                                                                  if (s1 === peg$FAILED) {
                                                                                                    s1 = input.substr(peg$currPos, 5);
                                                                                                    if (s1.toLowerCase() === peg$c48) {
                                                                                                      peg$currPos += (5);
                                                                                                    } else {
                                                                                                      s1 = peg$FAILED;
                                                                                                      if (peg$silentFails === 0) { peg$fail(peg$e48); }
                                                                                                    }
                                                                                                    if (s1 === peg$FAILED) {
                                                                                                      s1 = peg$parseJoinKeyword();
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseWhitespace();
      if (s3 === peg$FAILED) {
        s3 = peg$parseLeftParenthesis();
        if (s3 === peg$FAILED) {
          s3 = peg$parseRightParenthesis();
        }
      }
      peg$silentFails--;
      if (s3 !== peg$FAILED) {
        peg$currPos = s2;
        s2 = undefined;
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f2(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseJoinKeyword() {
    let s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parseJoinDirection();
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parseWhitespace();
    if (s2 === peg$FAILED) {
      s2 = null;
    }
    s3 = peg$parseJoinType();
    if (s3 === peg$FAILED) {
      s3 = null;
    }
    s4 = peg$parseWhitespace();
    if (s4 !== peg$FAILED) {
      s5 = input.substr(peg$currPos, 4);
      if (s5.toLowerCase() === peg$c33) {
        peg$currPos += (4);
      } else {
        s5 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e33); }
      }
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f3(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseJoinDirection() {
    let s0;

    s0 = input.substr(peg$currPos, 4);
    if (s0.toLowerCase() === peg$c35) {
      peg$currPos += (4);
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e35); }
    }
    if (s0 === peg$FAILED) {
      s0 = input.substr(peg$currPos, 5);
      if (s0.toLowerCase() === peg$c42) {
        peg$currPos += (5);
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e42); }
      }
      if (s0 === peg$FAILED) {
        s0 = input.substr(peg$currPos, 4);
        if (s0.toLowerCase() === peg$c28) {
          peg$currPos += (4);
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e28); }
        }
      }
    }

    return s0;
  }

  function peg$parseJoinType() {
    let s0;

    s0 = input.substr(peg$currPos, 5);
    if (s0.toLowerCase() === peg$c40) {
      peg$currPos += (5);
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e40); }
    }
    if (s0 === peg$FAILED) {
      s0 = input.substr(peg$currPos, 5);
      if (s0.toLowerCase() === peg$c31) {
        peg$currPos += (5);
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e31); }
      }
    }

    return s0;
  }

  function peg$parseParameter() {
    let s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c49) {
      s1 = peg$c49;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e49); }
    }
    if (s1 === peg$FAILED) {
      s1 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c50) {
        s2 = peg$c50;
        peg$currPos += 2;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$e50); }
      }
      if (s2 !== peg$FAILED) {
        s3 = input.charAt(peg$currPos);
        if (peg$r0.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e51); }
        }
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f4(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseCollapsedColumns() {
    let s0, s1;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c51) {
      s1 = peg$c51;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e52); }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f5();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseWhitespace() {
    let s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = input.charAt(peg$currPos);
    if (peg$r1.test(s2)) {
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e53); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = input.charAt(peg$currPos);
        if (peg$r1.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e53); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f6(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseGenericToken() {
    let s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = input.charAt(peg$currPos);
    if (peg$r2.test(s2)) {
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$e54); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = input.charAt(peg$currPos);
        if (peg$r2.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$e54); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f7(s1);
    }
    s0 = s1;

    return s0;
  }

  peg$result = peg$startRuleFunction();

  const peg$success = (peg$result !== peg$FAILED && peg$currPos === input.length);
  function peg$throw() {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
  if (options.peg$library) {
    return /** @type {any} */ ({
      peg$result,
      peg$currPos,
      peg$FAILED,
      peg$maxFailExpected,
      peg$maxFailPos,
      peg$success,
      peg$throw: peg$success ? undefined : peg$throw,
    });
  }
  if (peg$success) {
    return peg$result;
  } else {
    peg$throw();
  }
}

const peg$allowedStartRules = [
  "Expression"
];

export {
  peg$allowedStartRules as StartRules,
  peg$SyntaxError as SyntaxError,
  peg$parse as parse
};
